import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import EquipmentGroupsDt from '@/services/dataTransferModules/equipmentGroupsDt'

export default function useEquipmentGroups(params = {}) {
	const equipmentGroupsDt = new EquipmentGroupsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingEquipmentGroup: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: fullEquipmentGroups,
		getEntities: getEquipmentGroups,

		hashedEntities: hashedEquipmentGroups,
		getHashedEntities: getHashedEquipmentGroups,

		createEntity: createEquipmentGroups,

		entity: equipmentGroup,
		getEntity: getEquipmentGroup,

		entityPopup: equipmentGroupsPopup,
		getEntityPopup: getEquipmentGroupsPopup,

		entityPreview: previewEquipmentGroups,
		getEntityPreview: getEquipmentGroupsPreview,

		patchEntity: patchEquipmentGroups,
		updateEntity: putEquipmentGroups,

		deleteEntity: deleteEquipmentGroups,
	} = useBlProviders(
		equipmentGroupsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading equipment!'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		fullEquipmentGroups,
		hashedEquipmentGroups,
		previewEquipmentGroups,
		equipmentGroupsPopup,
		equipmentGroup,

		getEquipmentGroups,
		getHashedEquipmentGroups,
		getEquipmentGroupsPreview,
		getEquipmentGroupsPopup,
		createEquipmentGroups,
		patchEquipmentGroups,
		putEquipmentGroups,
		deleteEquipmentGroups,
		getEquipmentGroup,

		defaults,
	}
}
